<template>
    <div class="address-section">
        <div class="container">
            <div class="content-wrapper">
                <!-- Left Side - Building Image -->
                <div class="image-container">
                    <div class="image-wrapper">
                        <img src="/wp-content/uploads/2024/02/companyy.png" alt="Socrates Legacy Office"
                            class="building-image">
                    </div>
                </div>

                <!-- Right Side - Contact Information -->
                <div class="contact-container">
                    <!-- Registered Office Address -->
                    <div class="contact-block">
                        <h2 class="contact-title">Registered Office Address:</h2>
                        <p class="contact-text">Hamchaku, Mutsamudu</p>
                        <p class="contact-text">Autonomes Island of Anjouan Union of Comoros.</p>
                    </div>

                    <!-- Phone -->
                    <div class="contact-block">
                        <h2 class="contact-title">Phone:</h2>
                        <p class="contact-text">(+1) 315 309 0077</p>
                    </div>

                    <!-- Email -->
                    <div class="contact-block">
                        <h2 class="contact-title">E-mail:</h2>
                        <p class="contact-text">support@socrateslegacy.com</p>
                    </div>

                    <!-- Call to Action -->
                    <div class="cta-block">
                        <h2 class="cta-title">Need help or have a questions?</h2>
                        <a href="/contact-us" class="cta-button">
                            Send a Message
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'AddressSection'
}
</script>

<style scoped>
.address-section {
    background: #f5f5f5;
    padding: 100px 0;
    position: relative;
    overflow: hidden;
}

.container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 20px;
}

.content-wrapper {
    display: flex;
    align-items: center;
    gap: 80px;
    /* background: #fff; */
    /* border-radius: 20px; */
    /* padding: 60px; */
    /* box-shadow: 0 10px 50px rgba(0, 0, 0, 0.05); */
}

/* Left Side - Building Image */
.image-container {
    flex: 0 0 45%;
}

.image-wrapper {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
}

.building-image {
    width: 100%;
    height: auto;
    max-width: 500px;
    object-fit: contain;
    display: block;
}

/* Right Side - Contact Information */
.contact-container {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 35px;
}

.contact-block {
    border-bottom: 1px solid #e0e0e0;
    padding-bottom: 25px;
}

.contact-block:last-of-type {
    border-bottom: none;
    padding-bottom: 0;
}

.contact-title {
    color: #1a1a1a;
    font-size: 1.5rem;
    font-weight: 700;
    margin-bottom: 10px;
    line-height: 1.3;
}

.contact-text {
    color: #666;
    font-size: 1.1rem;
    line-height: 1.7;
    margin: 0 0 8px 0;
}

.contact-text:last-child {
    margin-bottom: 0;
}

/* CTA Block */
.cta-block {
    margin-top: 15px;
}

.cta-title {
    color: #1a1a1a;
    font-size: 1.5rem;
    font-weight: 700;
    margin-bottom: 20px;
    line-height: 1.3;
}

.cta-button {
    display: inline-block;
    background: linear-gradient(135deg, #c7a014 0%, #a5840c 100%);
    color: #fff;
    font-size: 15px;
    font-weight: 600;
    padding: 8px 32px;
    border-radius: 3px;
    text-decoration: none;
    display: inline-block;
    transition: all 0.3s ease;
    box-shadow: 0 8px 25px rgba(212, 175, 55, 0.3);
    letter-spacing: 0.5px;
}

.cta-button:hover {
    transform: translateY(0px);
    box-shadow: 0 12px 35px rgba(212, 175, 55, 0.5);
    background: linear-gradient(135deg, #927a1a 0%, #8d7118 100%);
}

/* Responsive Design */
@media (max-width: 992px) {
    .content-wrapper {
        gap: 60px;
        padding: 50px 40px;
    }

    .image-container {
        flex: 0 0 40%;
    }

    .contact-title {
        font-size: 1.3rem;
    }

    .cta-title {
        font-size: 1.3rem;
    }

    .contact-text {
        font-size: 1rem;
    }
}

@media (max-width: 768px) {
    .address-section {
        padding: 60px 0;
    }

    .content-wrapper {
        flex-direction: column;
        gap: 40px;
        padding: 40px 30px;
    }

    .image-container {
        flex: 0 0 100%;
        max-width: 400px;
        margin: 0 auto;
    }

    .contact-container {
        gap: 30px;
        width: 100%;
    }

    .contact-block {
        padding-bottom: 20px;
    }

    .contact-title {
        font-size: 1.2rem;
    }

    .cta-title {
        font-size: 1.2rem;
    }

    .contact-text {
        font-size: 0.95rem;
    }
}

@media (max-width: 480px) {
    .address-section {
        padding: 40px 0;
    }

    .content-wrapper {
        padding: 30px 20px;
        gap: 30px;
    }

    .building-image {
        max-width: 100%;
    }

    .contact-container {
        gap: 25px;
    }

    .contact-block {
        padding-bottom: 18px;
    }

    .contact-title {
        font-size: 1.1rem;
        margin-bottom: 8px;
    }

    .cta-title {
        font-size: 1.1rem;
        margin-bottom: 15px;
    }

    .contact-text {
        font-size: 0.9rem;
        line-height: 1.6;
        margin-bottom: 6px;
    }

    .cta-button {
        width: 100%;
        text-align: center;
        padding: 12px 24px;
        font-size: 0.95rem;
    }

    .cta-block {
        margin-top: 10px;
    }
}
</style>
